module.exports = __webpack_public_path__ + "img/01.17c30891.png";